module.exports = __webpack_public_path__ + "static/img/KtyLOGO.2c3f968.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/KtyLOGO.png
// module id = bX9j
// module chunks = 1